<app-header-modal [color]="'secondary-2'" [title]="title">
  <div icon *ngIf="showPalletDetails">
    <i class="uil uil-arrow-left" (click)="goBackToMap()"></i>
  </div>
  <div class="status-header" status *ngIf="showPalletDetails">
    <i class="uil uil-times" (click)="close()"></i>
  </div>
</app-header-modal>
<div class="content">
  <ng-container *ngIf="showPositionDetails">
    <mat-tab-group mat-align-tabs="center" [selectedIndex]="data?.selectedTabIndex">
      <mat-tab label="Detalhes da {{rowCoords ? 'Linha' : 'Coluna'}}">
        <app-pigeonhole-row-column-details
          [occupationList]="occupationList"
          [coords]="rowCoords ? rowCoords : columnCoords"
          [pigeonholes]="pigeonholes">
        </app-pigeonhole-row-column-details>
      </mat-tab>
      <mat-tab label="Pallets ({{packages?.length}})">
        <app-package-list-details 
          [packages]="packages"
          (goToPalletDetails)="openPalletDetails($event)"
          [palletToScrollTo]="data?.scrollTo">
        </app-package-list-details>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <ng-container *ngIf="showPalletDetails">
    <app-map-pallet-details [data]="palletDetails"></app-map-pallet-details>
  </ng-container>
</div>
